module.exports = __webpack_public_path__ + "static/media/ico-relay.36721ffd.svg";